import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { GenericCrudAddComponent } from 'src/app/libs/components/generic-crud/generic-crud-add.component';
import { CompanySeasonality } from 'src/app/models';

@Component({
    selector: 'app-company-seasonalities-add',
    templateUrl: './company-seasonalities-add.component.html',
    styleUrl: './company-seasonalities-add.component.sass',
    standalone: false
})
export class CompanySeasonalitiesAddComponent extends GenericCrudAddComponent<CompanySeasonality> {


  override initFormGroup(): FormGroup<any> {
    const group = this.fb.group({
      name: [],
      startDate: [],
    })
    return group;
  }

}
